module.exports = __webpack_public_path__ + "img/poziom4.4972a374.svg";